/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";
import CertificationMobile from "../../components/popups/CertificationMobile";

import { ChangeMobileNumber } from "../../components/common/Common";

import "../../css/style.css";

//휴대폰 번호 변경
const ChangeMobile = () => {
  const mem_idx = Number(localStorage.getItem("mem_idx"));
  const navigate = useNavigate();

  const [varMobile,setMobile] = useState({});

  useEffect(() => {
    const newMobile = {mem_idx:mem_idx,mem_mobile:"",mem_cert:"",chk_mobile:false,mem_certcode:""};
    setMobile(newMobile);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    if(name === "mem_mobile") {
      const svalue = ChangeMobileNumber(value);
      setMobile({...varMobile,mem_mobile:svalue});
    } else {
      setMobile({...varMobile,[name]:value});
    }
  }

  const onUpdateMobileHandler = async(e) => {
    if(!window.confirm(varMobile.mem_mobile+'\n휴대폰 번호를 변경합니까?')) return false;

    const sendData = {mem_idx:mem_idx,mem_mobile:varMobile.mem_mobile};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_my_mobile`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        //페이지이동
        navigate(`/MyInfo`);
      } else {
        alert(datas.message);
      }
    });    
  }

  return (
    <div className="vh-container">
      <Header varGoToMain={false} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'휴대폰 번호 변경'}/>
        <div className="vh-content-body ms25">
          <div className="vh-form-guide">
						<p>변경하시려는 휴대폰 번호 정보를 기재하세요</p>
					</div>
          <CertificationMobile varMobile={varMobile} setMobile={setMobile} onChangeInputHandler={onChangeInputHandler}/>
					<div className="form-contoller flex-horizontal mt-auto">
						<Link to={"/MyInfo"} className="form-contoller-btn btn-white">취소</Link>
						<button className="form-contoller-btn" onClick={onUpdateMobileHandler}>변경 정보 저장</button>
					</div>
        </div>
      </div>
    </div>
  );
}
export default ChangeMobile;